import { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../services/firebase';

// Default stores as fallback
const defaultStores = [
  { id: 'wholefoods', name: 'Whole Foods', icon: 'leaf', color: '#2D6A4F' },
  { id: 'trader_joes', name: "Trader Joe's", icon: 'bag', color: '#D32F2F' },
  { id: 'target', name: 'Target', icon: 'target', color: '#CC0000' },
  { id: 'walmart', name: 'Walmart', icon: 'shopping-cart', color: '#0071CE' },
  { id: 'costco', name: 'Costco', icon: 'building', color: '#0066B2' },
  { id: 'safeway', name: 'Safeway', icon: 'shopping-basket', color: '#E53935' },
  { id: 'kroger', name: 'Kroger', icon: 'shopping-cart', color: '#003DA5' },
  { id: 'sprouts', name: 'Sprouts', icon: 'carrot', color: '#00923F' },
  { id: 'publix', name: 'Publix', icon: 'store', color: '#008446' },
  { id: 'aldi', name: 'Aldi', icon: 'shopping-bag', color: '#FF6600' },
];

export const useStores = () => {
  const [stores, setStores] = useState(defaultStores);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchStores = async () => {
      try {
        setLoading(true);
        const snapshot = await getDocs(collection(db, 'stores'));
        const storesData = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        if (storesData.length > 0) {
          setStores(storesData);
        }
      } catch (error) {
        console.error('Error fetching stores:', error);
        // Keep default stores on error
      } finally {
        setLoading(false);
      }
    };

    fetchStores();
  }, []);

  return { stores, loading };
};
